var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStandardTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 29.1663C7.17567 29.1663 0.833252 22.8239 0.833252 14.9997C0.833252 7.17542 7.17567 0.833008 14.9999 0.833008C22.8242 0.833008 29.1666 7.17542 29.1666 14.9997C29.1666 22.8239 22.8242 29.1663 14.9999 29.1663ZM14.9999 26.333C18.0057 26.333 20.8884 25.139 23.0138 23.0136C25.1392 20.8881 26.3333 18.0055 26.3333 14.9997C26.3333 11.9939 25.1392 9.11121 23.0138 6.9858C20.8884 4.86039 18.0057 3.66634 14.9999 3.66634C11.9941 3.66634 9.11145 4.86039 6.98604 6.9858C4.86063 9.11121 3.66659 11.9939 3.66659 14.9997C3.66659 18.0055 4.86063 20.8881 6.98604 23.0136C9.11145 25.139 11.9941 26.333 14.9999 26.333V26.333ZM16.4166 14.9997H22.0833V17.833H13.5833V7.91634H16.4166V14.9997Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardTime);
export default __webpack_public_path__ + "static/media/Standard-Time.c6397dd3125a517a054489ae84aa09db.svg";
export { ForwardRef as ReactComponent };